import { StarIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction, useState } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import classNames from "src/helpers/classNames";

interface RatingFormProps {
  rating: number;
  setRating: Dispatch<SetStateAction<number>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  isFormSubmittedOnce: boolean;
}

const RatingForm = ({
  rating,
  setRating,
  setReviewStep,
  isFormSubmittedOnce,
}: RatingFormProps) => {
  const t = useTranslations("ReviewForm");

  const [hoverRating, setHoverRating] = useState(0);
  const handleMouseEnter = (rating: number) => {
    setHoverRating(rating);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  return (
    <>
      <section className="m-auto flex flex-col items-center gap-10">
        <h2 className="text-2xl font-semibold">{t("your_overral_rating")}</h2>
        <div dir="ltr" className="group flex items-center">
          {Array.from(Array(5).keys()).map((item, index) => (
            <button
              key={item}
              onClick={() => setRating(index + 1)}
              onMouseEnter={() => {
                handleMouseEnter(index);
              }}
              onMouseLeave={handleMouseLeave}
              type="button"
            >
              <StarIcon
                className={classNames(
                  "h-12 w-12 flex-shrink-0 fill-white !text-gray-900",
                  index + 1 <= rating ? "!fill-amber-400" : "",
                  index <= hoverRating ? "group-hover:!fill-amber-400" : ""
                )}
                aria-hidden="true"
              />
            </button>
          ))}
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton onClick={() => setReviewStep(9)} disabled={rating < 1}>
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={rating < 1}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default RatingForm;
